import React from "react";

const PracticeScore = ({ score, type = '' }) => {
  // Determine color scheme based on score
  const getScoreStyle = (score) => {
    if (score === null || score === undefined || isNaN(Number(score))) {
      return {
        backgroundColor: "#F3F4F6",
        color: "#6B7280",
        border: "1px solid #E5E7EB",
      };
    }
    const numScore = Number(score);
    if (numScore >= 90) {
      return {
        backgroundColor: "#D1FAE5",
        color: "#065F46",
        border: "1px solid #A7F3D0",
      };
    } else if (numScore >= 60) {
      return {
        backgroundColor: "#FFF7ED",
        color: "#B45309",
        border: "1px solid #FDBA74",
      };
    } else {
      return {
        backgroundColor: "#FEE2E2",
        color: "#991B1B",
        border: "1px solid #FECACA",
      };
    }
  };

  const isUnattempted =
    score === null || score === undefined || isNaN(Number(score));
  const scoreStyle = getScoreStyle(type && (type === 'writing' || type === 'speaking') && score ? Math.ceil((score / 9) * 100) : score);

  return (
    <div className="score-info">
      <span
        className="score-badge"
        style={{
          padding: "4px 12px",
          borderRadius: "20px",
          fontSize: "11px",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          ...scoreStyle,
        }}
      >
        {isUnattempted ? "Unattempted" : type && (type === 'writing' || type === 'speaking') ? `Band: ${score}` :  `Score: ${Number(score)}%`}
      </span>
    </div>
  );
};

export default PracticeScore;
